import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Spinner from '../components/Spinner'
import { getAllCashOrders, getAllInvoiceOrders, getAllOrders, getSingleOrder, reset, importMultipleFromNumber } from '../features/order/orderSlice'
import Order from '../components/Order'
import Orders from '../components/Orders'
import OrderProducts from '../components/OrderProducts'
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

function Dashboard() {
  const [showImporter, setShowImporter] = useState(false)
  const [isAlex, setIsAlex] = useState(false)

  const [numurs, setNumurs] = useState('')

  const [showAll, setShowAll] = useState(false)
  const [showCash, setShowCash] = useState(false)
  const [started, setStarted] = useState(false)
  const [title, setTitle] = useState('Pasūtījumi: ')
  const [page, setPage] = useState(1)
  const [count, setCount] = useState(0)

  const [orderCount, setOrderCount] = useState(null)
  const [startId, setStartId] = useState(null)

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams(); // Hook to access query parameters

  const { user } = useSelector((state) => state.auth)

  const { order, orders, isLoading, isError, message } = useSelector(
    (state) => state.order
  )

  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState(null);

  useEffect(() => {
    const orderId = searchParams.get('orderId');
    
    if (orderId) {
      dispatch(getSingleOrder(orderId));
    }
  }, []);

  useEffect(() => {
    if (!user) {
      navigate('/login')
    } else {
      if (user.username === 'aleksis') {
        setIsAlex(true);
      }
    }

    if (order) {
      setSelectedOrder(order)
    }

    if (orders) {
      if(orders.data){
        if(orders.data.length > 0) {
          setSelectedOrders(orders.data)
          setCount(orders.pages)
          setSelectedOrder(JSON.parse(orders.data[0].response_data))
        } else{
          setTitle('Pasūtījumi netika atrasti')
        }
      }
      
    }


    if (isError) {
      toast.error(message);
    }
  
    // Dispatch reset action when component unmounts
    return () => {
      dispatch(reset());
    };
  }, [user, order, orders, isError, message, dispatch]);

  const onChange = (e) => {
    setNumurs(e.target.value);
  }

  const getOrder = async (e) => {
    e.preventDefault()
    dispatch(getSingleOrder(numurs));
  }

  useEffect(() => {
    if(!started) {
      return
    }
    if(showAll) {
      setTitle('Skaidras naudas & pasūtījumi ar rēķiniem: ')
      dispatch(getAllOrders(page))
    }else if(showCash) {
      setTitle('Skaidras naudas pasūtījumi: ')
      dispatch(getAllCashOrders(page))
    } else{
      setTitle('Pasūtījumi ar rēķiniem: ')
      dispatch(getAllInvoiceOrders(page))
    }
  }, [showAll, showCash, started, page])

  const changeOrders = (button_type) => {
    setStarted(true)
    if (button_type === 'all') {
      setShowAll(true)
      setShowCash(false)
    } else if (button_type === 'cash') {
      setShowAll(false)
      setShowCash(true)
    } else {
      setShowAll(false)
      setShowCash(false)
    }
  }

  const handleOrderClick = (order) => {
    setSelectedOrder(order.response_data);
  };

  const pageRight = () => {
    if(page < count) {
      setPage(page + 1)
    }
  }

  const pageleft = () => {
    if(page > 1) {
      setPage(page - 1)
    }
  }

  const submitImportMultiple = async () => {
    const data = {
      startId: startId,
      count: orderCount
    }

    dispatch(importMultipleFromNumber(data))
  }

  if (isLoading) {
    return <Spinner />
  }
  
  return (
    <div className='dashboard'>
      <div className="controls">
        <form className="dashboard-search" onSubmit={getOrder}>
            <div className='form-group search'>
              <input
                type='text'
                className='form-control'
                id='numurs'
                name='numurs'
                value={numurs}
                placeholder='Ievadi pasūtījuma numuru'
                onChange={onChange}
              />
              <button type='submit' className='btn poga'>
                Meklēt
              </button>
            </div>
          </form>
          <div className="other-controls">
              <button onClick={() => changeOrders('cash')}className='btn poga'>
                  Skaidras naudas
              </button>
              <button onClick={() => changeOrders('invoice')}className='btn poga'>
                  Ar rēķinu
              </button>
              <button onClick={() => changeOrders('all')}className='btn poga'>
                  Visi
              </button>
          </div>
      </div>
      <div className="import-mode">
        
        <label htmlFor="import-mode" onClick={() => setShowImporter(!showImporter)}>Importēšanas režīms</label>
        <input type="checkbox" name="" id="" checked={showImporter} onChange={() => setShowImporter(!showImporter)}/>
      </div>
      <div className="info">
        <div className="order-tables">
          <div className="single-order">
            <div className="order-info">
              <Order order={selectedOrder}/>
            </div>
          </div>
          <div className="orders-table">
            <div className="orders-table-container">
              <Orders orders={selectedOrders} onOrderClick={handleOrderClick} toShow={showAll ? 'all' : showCash ? 'cash' : 'invoice'} title={title}/>
            </div>
            {started ? (<>
              <p>Lapas numurs: {page} no {count}</p>
              <div className="orders-table-controls">
                <button onClick={pageleft}><FaAngleLeft/></button>
                <button onClick = {pageRight}><FaAngleRight/></button>
              </div>
            </>):(<></>)}
            
          </div>
        </div>
        <div className="order-products">
          <OrderProducts order={selectedOrder}/>
        </div>
      </div>
      {showImporter &&
        <div className="order-json padding-40-top flex column gap-10">
          <h3>Importēt vairākus:</h3>
          <div className="flex column gap-5 width-20">
            <label>Pasūtījums ar kuru sākt</label>
            <input type="number" className='basic' value={startId} onChange={(e) => setStartId(e.target.value)}/>
          </div>
          <div className="flex column gap-5 width-20">
            <label>Pasūtījumu skaits</label>
            <input type="number" className='basic' value={orderCount} onChange={(e) => setOrderCount(e.target.value)}/>
          </div>
          <button type='submit' className='btn poga width-20' onClick={() => submitImportMultiple()}>
            Importēt
          </button>
          {/* <pre>{JSON.stringify(selectedOrder, null, 2)}</pre> */}
        </div>
      }
      {isAlex && 
        <div className="order-json padding-40-top">
          <h3>Order JSON:</h3>
          <pre>{JSON.stringify(selectedOrder, null, 2)}</pre>
        </div>
      }
      
    </div>
  )
}

export default Dashboard
